import { render, staticRenderFns } from "./StorePagePreview.vue?vue&type=template&id=524a89cc&scoped=true"
import script from "./StorePagePreview.vue?vue&type=script&lang=js"
export * from "./StorePagePreview.vue?vue&type=script&lang=js"
import style0 from "./StorePagePreview.vue?vue&type=style&index=0&id=524a89cc&prod&lang=scss"
import style1 from "./StorePagePreview.vue?vue&type=style&index=1&id=524a89cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a89cc",
  null
  
)

export default component.exports